import { INITIAL_FILTERS } from "../search/supplierFilters";

const labelFor = (options, id) => {
  const match = (options || []).find((option) => option.id === id);

  return match?.label || match?.defaultTitle || null;
};

const joinPhrases = (phrases) => {
  if (phrases.length <= 1) return phrases[0] || "";
  if (phrases.length === 2) return `${phrases[0]} and ${phrases[1]}`;

  return `${phrases.slice(0, -1).join(", ")} and ${phrases[phrases.length - 1]}`;
};

export const buildFilterSummary = (filters, { containerOptions, containerTypes, currency }) => {
  const phrases = [];

  const optionLabel = labelFor(containerOptions, filters.containerOptionId);
  if (optionLabel) phrases.push(optionLabel);

  const typeLabel = labelFor(containerTypes, filters.containerTypeId);
  if (typeLabel) phrases.push(typeLabel);

  if (filters.maxVolume !== INITIAL_FILTERS.maxVolume) {
    phrases.push(`up to ${filters.maxVolume}kg`);
  }

  if (filters.maxPricePerKg !== INITIAL_FILTERS.maxPricePerKg) {
    phrases.push(
      `under ${currency || "GHS"} ${filters.maxPricePerKg.toFixed(2)} per kg`
    );
  }

  return joinPhrases(phrases);
};

export const emptyStateCopy = ({ cause, filters, summary, nearestKm, currency }) => {
  if (cause === "filters") {
    return {
      title: "No Match For These Filters",
      body: summary
        ? `No supplier within ${filters.radiusKm}km offers ${summary}. Would you like to clear these filters?`
        : "No supplier within the current radius matches your filters. Would you like to clear them?",
      confirmLabel: "Clear Filters",
      cancelLabel: "Keep",
    };
  }

  if (cause === "radius") {
    return {
      title: "No Supplier Nearby",
      body: `There is no supplier within ${filters.radiusKm}km of you. Nearest supplier to you is ${Math.ceil(
        nearestKm
      )}km away. Should we widen your search radius to reach it?`,
      confirmLabel: "Yes",
      cancelLabel: "No",
    };
  }

  return {
    title: "Unavailable In Your Area",
    body: "Unfortunately, we are not operating in your area for now. Contact our team for more details.",
    confirmLabel: "Okay",
    cancelLabel: null,
    currency,
  };
};
